import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { RelatorioProdutividade } from '../../types/indicadores';
import { relatoriosProdutividadeService } from '../../services';

const columns: ResourceColumn<RelatorioProdutividade>[] = [
  { header: "Setor", accessor: "setor" },
  { header: "Período", render: (item) => item.periodo_inicio + " a " + item.periodo_fim },
  { header: "Gerado por", accessor: "gerado_por" },
  { header: "Data de geração", accessor: "data_geracao" }
];

export const RelatoriosProdutividadeListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
  <ResourceListPage
    title="Relatórios de produtividade"
    description="Relatórios consolidados por setor."
    columns={columns}
    service={relatoriosProdutividadeService}
    createPath="/admin/indicadores/relatorios-produtividade/novo"
      onEdit={(item) => item.id && navigate("/admin/indicadores/relatorios-produtividade/editar", { state: { record: item } })}
  />
  );
};